export const BLOG_BASE = "https://blog.premagic.com"

type BlogEntry = {
  slug: string
  defaultUtm?: Record<string, string>
}

export const BLOG_LINKS = {
  home: { slug: "/" },
  privacy: { slug: "/privacy/" },
  terms: { slug: "/terms/" },
  avatarStudio: {
    slug: "/avatar-studio-personalized-ai-avatars-for-event-engagement/",
  },
  photoDistribution: {
    slug: "/share-event-photos-with-guests-using-face-recognition-the-ultimate-solution-for-event-photography-with-premagic/",
  },
  attendingPosters: {
    slug: "/create-and-share-i-am-attending-posters-with-premagic/",
  },
  photoGalleries: {
    slug: "/choose-premagic-the-smart-photo-sharing-app/",
  },
  advocacyPosters: {
    slug: "/what-are-event-advocacy-posters-and-why-you-need-to-have-them-at-your-event-right-away/",
  },
  rethinkingAttendingPosters: {
    slug: "/rethinking-i-am-attending-posters-for-saasboomi-annual-2025/",
  },
  etl2025Win: {
    slug: "/premagic-wins-best-use-of-technology-for-marketing-an-event-at-event-tech-awards-2025/",
    defaultUtm: {
      utm_source: "ticker",
      utm_medium: "banner",
      utm_campaign: "etl2025",
    },
  },
  adamParryAdvisor: {
    slug: "/adam-parry-joins-premagic-as-strategic-advisor/",
  },
  saudiEventShow: {
    slug: "/team-premagics-experience-at-saudi-event-show-2024/",
    defaultUtm: {
      utm_source: "casestudy",
      utm_medium: "website",
      utm_id: "opentext",
    },
  },
} as const satisfies Record<string, BlogEntry>

export type BlogLinkKey = keyof typeof BLOG_LINKS

export function blogUrl(
  key: BlogLinkKey,
  utm?: Record<string, string>,
): string {
  const entry: BlogEntry = BLOG_LINKS[key]
  const merged = { ...(entry.defaultUtm ?? {}), ...(utm ?? {}) }
  const query = new URLSearchParams(merged).toString()
  const url = `${BLOG_BASE}${entry.slug}`
  return query ? `${url}?${query}` : url
}
